// Upgrade img.lqip elements once the full image has decoded, clearing the
// blur and the placeholder background so the sharp image is revealed.
export function initLQIP() {
  const imgs = document.querySelectorAll("img.lqip");
  imgs.forEach((img) => {
    if (img.complete && img.naturalWidth > 0) {
      img.classList.add("is-loaded");
      return;
    }
    img.addEventListener("load", () => img.classList.add("is-loaded"), { once: true });
    img.addEventListener("error", () => img.classList.add("is-loaded"), { once: true });
  });
}
